import { Injectable } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import { ProductsOpenPlatformService, ProductsResponseOP, ProductOPReq } from '@cemex-core/cmx-api';
import {
  ADTProductActions,
  AdtProductsActionTypes,
  FetchProductsFailure,
  LoadProductsResponse,
} from '../actions/products.actions';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

/**
 * An effect which monitors the actions$ Observable for (job-site) LOAD operations
 * and then
 */
@Injectable()
export class AdtProductsEffects implements IEffect {
  /**
   * Fetches Product list of admixtures with contracts
   */

  adtFetchProducts$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(AdtProductsActionTypes.FETCH_PRODUCTS),
      switchMap((action: ADTProductActions) => {
        const request = action.payload as ProductOPReq;

        return this.productsApi.getProducts(request).pipe(
          map((response: ProductsResponseOP) => {
            return new LoadProductsResponse(response);
          }),
          catchError((error) => of(new FetchProductsFailure(error))),
        );
      }),
    ),
  );

  /**
   *
   * @param {Store<OrderBuilderState>} store the usual in-memory store of application state.
   * @param {Actions} actions$ an Observable subclass which deals with actions
   *                           taken by or in the application
   * @param {ProductLoaderService} productLoaderService
   */
  constructor(
    private actions$: Actions,
    private productsApi: ProductsOpenPlatformService,
  ) {}
}
